module.exports = __webpack_public_path__ + "static/media/hot_jql.3dbe05d1.png";